import React from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useMutation } from '@tanstack/react-query';
import { Container, Form, Button, Segment, Header, Grid, Message, Divider } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';

function Settings() {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    current_password: '',
    new_password: '',
    confirm_password: '',
    notifications: {
      email: user?.notifications?.email || false,
      recipe: user?.notifications?.recipe || false,
    },
  });

  const { mutate: updateProfile, isLoading: isUpdating } = useMutation({
    mutationFn: (data) => Promise.resolve(data), // Replace with actual API call
  });

  const handleChange = (e, { name, value, checked }) => {
    if (name.startsWith('notifications.')) {
      const notificationType = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        notifications: {
          ...prev.notifications,
          [notificationType]: checked,
        },
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateProfile(formData);
  };

  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Settings</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Header as="h1">Settings</Header>

          <Form onSubmit={handleSubmit}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Header as="h3">Profile Information</Header>
                  <Form.Input
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <Form.Input
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Grid.Column>
              </Grid.Row>

              <Divider />

              <Grid.Row>
                <Grid.Column width={16}>
                  <Header as="h3">Change Password</Header>
                  <Form.Input
                    label="Current Password"
                    name="current_password"
                    type="password"
                    value={formData.current_password}
                    onChange={handleChange}
                  />
                  <Form.Input
                    label="New Password"
                    name="new_password"
                    type="password"
                    value={formData.new_password}
                    onChange={handleChange}
                  />
                  <Form.Input
                    label="Confirm New Password"
                    name="confirm_password"
                    type="password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                  />
                </Grid.Column>
              </Grid.Row>

              <Divider />

              <Grid.Row>
                <Grid.Column width={16}>
                  <Header as="h3">Notification Preferences</Header>
                  <Form.Checkbox
                    label="Email Notifications"
                    name="notifications.email"
                    checked={formData.notifications.email}
                    onChange={handleChange}
                  />
                 
                  <Form.Checkbox
                    label="Recipe Notifications"
                    name="notifications.recipe"
                    checked={formData.notifications.recipe}
                    onChange={handleChange}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={16}>
                  <Button type="submit" primary loading={isUpdating}>
                    Save Changes
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
      </Container>
    </>
  );
}

export default Settings; 